import axios from 'axios';
import { useEffect, useReducer, useRef, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { useToast } from '../../services/ToastContext';
import { useOperatorsState } from '../../services/OperatorsList';
import { FieldModal } from '../field-modal/FieldModal';
import { useTranslation } from 'react-i18next';
import './breakdownList.scss';

type Props = {
  title: string;
  subtitle: string;
  data: any[];
  vertical?: boolean;
  icon: string;
  color?: string;
};

export const BreakdownList = (props: Props) => {
  const { operatorId, cpeId } = useParams();
  const updateMacRef: any = useRef(null);
  const { operatorList, loggedUserData } = useOperatorsState();
  const [selectedField, setSelectedField] = useState<any>();
  const [breakdownData, setBreakdownData] = useState<any>();
  const { showToastMessage } = useToast();
  const { t } = useTranslation();

  useEffect(() => {
    if (props.data) {
      setBreakdownData(props.data);
    }
  }, [props.data]);

  async function updateField(e: any) {
    try {
      if (e.type === 'Registered to') {
        await axios.patch(`op/${cpeId}/update/email`, { email: e.value });
      } else if (e.type === 'CPE Mac address') {
        await axios.patch(`op/${cpeId}/update/mac`, { macAddr: e.value });
      } else if (e.type === 'CPE Serial number' || e.type === 'Mac address') {
        await axios.patch(`op/${cpeId}/update/serial`, { serial: e.value });
      }
      showToastMessage(t('widgets.breakdown.updated'));

      const breakdownCopy = [...breakdownData];
      breakdownCopy.find((item) => item.key === e.type).value = e.value;
      setBreakdownData(breakdownCopy);
    } catch (err: any) {
      console.log(err);
      showToastMessage(err?.response?.data || t('widgets.breakdown.error'));
    }
  }

  function updateClick(item: any) {
    setSelectedField(item);
    updateMacRef.current.handleShow();
  }

  return (
    breakdownData && (
      <section
        className={'shadow-md retina-breakdown' + (props.vertical ? ' vertical' : '') + (props.color ? ' has-color' : '')}
        style={{ backgroundColor: props.color, color: 'black' }}
      >
        <header>
          <div className="wrapper">
            <img src={props.icon}></img>
            <span className="bold">{props.title}</span>
          </div>
        </header>

        <div className="body">
          {breakdownData.map(
            (item: any) =>
              item.key !== 'Configurations' &&
              item.show !== false && (
                <div key={item.key} className={'breakdown-item'}>
                  <div>{item?.key}</div>
                  <span>
                    {item?.value}
                    {item.showUpdate && (operatorId == loggedUserData?.operatorId || loggedUserData?.operatorId === 0) && (
                      <Button onClick={() => updateClick(item)}>{t('widgets.breakdown.update')}</Button>
                    )}
                  </span>
                </div>
              )
          )}
        </div>

        <FieldModal
          ref={updateMacRef}
          title={t('widgets.breakdown.updateTitle', { field: selectedField?.key })}
          value={selectedField?.value}
          confirmBtnText={t('widgets.breakdown.update')}
          onConfirm={updateField}
          field={selectedField?.key}
        />
      </section>
    )
  );
};
